/** Shared Lenis instance — App registers, Header/overlays stop/start */

let lenisInstance = null;

export function setLenis(instance) {
    lenisInstance = instance;
}

export function getLenis() {
    return lenisInstance;
}

export function stopLenis() {
    lenisInstance?.stop();
}

export function startLenis() {
    lenisInstance?.start();
}
